var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "customer-address",
    },
    [
      _c(
        "el-row",
        {
          staticStyle: { "flex-wrap": "wrap" },
          attrs: { gutter: 20, type: "flex", align: "top" },
        },
        [
          _vm._l(_vm.addressList, function (item) {
            return _c(
              "el-col",
              {
                key: item.id,
                attrs: { xl: 12, lg: 12, md: 12, sm: 24, xs: 24 },
              },
              [
                _c("el-card", { staticClass: "address-card" }, [
                  _c("div", { staticClass: "line-item" }, [
                    _c("div", { staticClass: "line-left" }, [
                      _vm._v(
                        _vm._s(_vm.$t("customer::customer-list::recipient")) +
                          "："
                      ),
                    ]),
                    _c("div", { staticClass: "content" }, [
                      _vm._v(_vm._s(item.userName)),
                    ]),
                  ]),
                  _c("div", { staticClass: "line-item" }, [
                    _c("div", { staticClass: "line-left" }, [
                      _vm._v(
                        _vm._s(_vm.$t("customer::customer-list::address")) +
                          "："
                      ),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "content",
                        staticStyle: { "word-break": "break-all" },
                      },
                      [_vm._v(" " + _vm._s(item.address) + " ")]
                    ),
                  ]),
                  _c("div", { staticClass: "line-item" }, [
                    _c("div", { staticClass: "line-left" }, [
                      _vm._v(
                        _vm._s(_vm.$t("customer::customer-list::email")) + "："
                      ),
                    ]),
                    _c("div", { staticClass: "content" }, [
                      _vm._v(_vm._s(item.userEmail)),
                    ]),
                  ]),
                  _c("div", { staticClass: "line-item" }, [
                    _c("div", { staticClass: "line-left" }, [
                      _vm._v(
                        _vm._s(_vm.$t("customer::customer-list::phone")) + "："
                      ),
                    ]),
                    _c("div", { staticClass: "content" }, [
                      _vm._v(_vm._s(item.phone)),
                    ]),
                  ]),
                ]),
              ],
              1
            )
          }),
          _vm.addressList.length === 0
            ? _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("el-card", [
                    _c("div", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("customer::customer-list::no_deliver_addr")
                        )
                      ),
                    ]),
                  ]),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }